export const getZoneSelectionAfterDeletion = (zones = [], deletedZoneId, removedZoneIds = []) => {
  if (!Array.isArray(zones) || deletedZoneId == null) return null;

  const deletedZoneKey = `${deletedZoneId}`;
  const removedZoneKeys = new Set(
    [deletedZoneKey, ...(Array.isArray(removedZoneIds) ? removedZoneIds : [])].map((id) => `${id}`),
  );
  const deletedZoneIndex = zones.findIndex((zone) => `${zone?.id}` === deletedZoneKey);
  if (deletedZoneIndex < 0) return null;

  const nextZone = zones.slice(deletedZoneIndex + 1).find((zone) => {
    return zone?.id != null && !removedZoneKeys.has(`${zone.id}`);
  });
  if (nextZone) return nextZone;

  return (
    zones
      .slice(0, deletedZoneIndex)
      .reverse()
      .find((zone) => zone?.id != null && !removedZoneKeys.has(`${zone.id}`)) || null
  );
};
